export default {
  playAriaLabel: {
    id: 'product_page_carousel_video_button_aria_label',
    defaultMessage: 'Play video for {productName}',
  },
  // TODO(PPI-7872): not requested for translation yet. Uncomment once the
  // translation for this key is available and the pause branch in
  // MarketingVideo.vue's `ariaLabel` computed is restored.
  // pauseAriaLabel: {
  //   id: 'product_page_carousel_video_pause_aria_label',
  //   defaultMessage: 'Pause video for {productName}',
  // },
} as const
